import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';

const RealisationsPortfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const realisations = [
    {
      id: 1,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/ykcn8y8r_8D238CB3-8262-45DA-88BB-46F7AEA00F24.png',
      title: 'Solution FAP et EGR',
      subtitle: 'Ssangyong 2.2 XDI – Creutzwald',
      category: 'FAP/EGR'
    },
    {
      id: 2,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/y97lh88t_4068DD2F-F916-49C5-BFEE-A672B3A8AC8E.png',
      title: 'Conversion E85',
      subtitle: 'Citroën Berlingo 1.6 VTI 120CV – JC Performance-57',
      category: 'E85'
    },
    {
      id: 3,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/qje8uyiv_B6CC1BDB-D15B-4711-924B-D44E68C00CD6.png',
      title: 'Conversion E85',
      subtitle: 'Opel Astra J 2011 – Creutzwald',
      category: 'E85'
    },
    {
      id: 4,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/owpz1v8i_165E2E63-FBE1-485D-BF4F-4E2D7A3C383B.png',
      title: 'Optimisation Stage 1',
      subtitle: 'Audi A3 TDI | +35 CV +60 NM – JC Performance-57',
      category: 'STAGE 1'
    },
    {
      id: 5,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/dcgv6b0k_FE946AFB-B3B9-40A4-AFAD-EFE5AE085F69.png',
      title: 'Reprogrammation Stage 1',
      subtitle: '1.5 BlueDCI 115CV | +25 CV +60 NM – Creutzwald',
      category: 'STAGE 1'
    },
    {
      id: 6,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/98hfnxun_6895D37B-30C3-4FC6-8D07-E7C2EE10E328.png',
      title: 'Solution Démarrage',
      subtitle: 'Calculateur BOSCH EDC15C7 Fiat Ducato – JC Performance-57',
      category: 'DÉMARRAGE'
    },
    {
      id: 7,
      image: 'https://customer-assets-0z36b82j.emergentagent.net/job_b92c909d-4b97-422f-875b-644c85b33d43/artifacts/j1w5y4x4_32C97E5B-C22D-455D-8D6B-02CD9B044A33.png',
      title: 'Bench & Boot',
      subtitle: 'Travail en mode Bench & Boot | Qualité & Sécurité – Creutzwald',
      category: 'EXPERTISE'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 relative overflow-hidden" id="portfolio">
      {/* Animated Background Effect */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-600 rounded-full blur-[120px] animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-red-700 rounded-full blur-[120px] animate-pulse delay-700"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center p-4 bg-red-600/10 rounded-full mb-6">
            <svg className="h-12 w-12 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
            </svg>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 uppercase">
            <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">
              Nos Dernières Interventions
            </span>
          </h2>
          <p className="text-red-600 font-bold text-2xl mb-2">
            🔥 EXPERTISE & RÉSULTATS GARANTIS 🔥
          </p>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Diagnostic automobile, électricité, reprogrammation moteur : découvrez nos interventions à Creutzwald
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {realisations.map((realisation) => (
            <div
              key={realisation.id}
              className="group relative bg-slate-800/30 backdrop-blur-sm rounded-2xl border-2 border-slate-700 hover:border-red-600 overflow-hidden transition-all duration-500 transform hover:scale-105 hover:-translate-y-2 cursor-pointer"
              onClick={() => setSelectedImage(realisation)}
            >
              {/* Category Badge */}
              <div className="absolute top-4 right-4 z-10 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg animate-pulse">
                {realisation.category}
              </div>

              {/* Image */}
              <div className="relative h-[500px] overflow-hidden">
                <img
                  src={realisation.image}
                  alt={realisation.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
                
                {/* Zoom Icon */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="bg-red-600 p-4 rounded-full">
                    <ZoomIn className="h-8 w-8 text-white" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-slate-950 to-transparent">
                <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-red-600 transition-colors">
                  {realisation.title}
                </h3>
                <p className="text-gray-300 font-semibold">{realisation.subtitle}</p>
              </div>

              {/* Glow Effect */}
              <div className="absolute inset-0 bg-red-600/0 group-hover:bg-red-600/5 transition-colors duration-300" />
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border-2 border-slate-700">
            <p className="text-white text-2xl font-bold mb-4">
              🚀 Votre véhicule mérite le meilleur !
            </p>
            <p className="text-gray-400 mb-6">
              Contactez-nous pour une prestation sur-mesure
            </p>
            <a
              href="tel:0749995728"
              className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-4 rounded-xl transition-all transform hover:scale-105 text-lg"
            >
              📞 07 49 99 57 28
            </a>
          </div>
        </div>
      </div>

      {/* Modal for full image */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 backdrop-blur-sm"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-red-600 transition-colors bg-slate-800/50 p-3 rounded-full"
          >
            <X className="h-8 w-8" />
          </button>
          <div className="max-w-6xl w-full">
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="mt-6 text-center">
              <h3 className="text-3xl font-bold text-white mb-2">{selectedImage.title}</h3>
              <p className="text-xl text-gray-300">{selectedImage.subtitle}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default RealisationsPortfolio;
